module.exports = __webpack_public_path__ + "images/emoji/izakaya_lantern.29a82b0161f6489a7033.png";